import Routes from "../routes";

const menuItems = [
  {
    text: "TOPICS",
    dropdownItems: [
      {
        text: "Understand",
        linkItems: [
          [
            {
              text: "What is OEE?",
              url: Routes.OEE.WhatIsOEE,
            },
            {
              text: "OEE Factors",
              url: Routes.OEE.Factors,
            },
            {
              text: "Six Big Losses",
              url: Routes.OEE.SixBigLosses,
            },
            {
              text: "Hidden Factory",
              url: Routes.OEE.HiddenFactory,
            },
            {
              text: "Practical OEE",
              url: Routes.OEE.PracticalOEE,
            },
          ],
        ],
      },
      {
        text: "Measure",
        linkItems: [
          [
            {
              text: "Calculate OEE",
              url: Routes.OEE.CalculatingOEE,
            },
            {
              text: "Implement OEE",
              url: Routes.OEE.ImplementingOEE,
            },
            {
              text: "Calculate TEEP",
              url: Routes.OEE.TEEP,
            },
            {
              text: "Visual OEE ™",
              url: Routes.OEE.VisualOEE,
            },
          ],
        ],
      },
      {
        text: "Improve",
        linkItems: [
          [
            {
              text: "Improve OEE",
              url: Routes.OEE.ImproveOEE,
            },
            {
              text: "World-Class OEE",
              url: Routes.OEE.WorldClassOEE,
            },
            {
              text: "Address the Six Big Losses",
              url: Routes.OEE.AddressSixBigLosses,
            },
            {
              text: "Takt Time",
              url: Routes.OEE.TaktTimeCluster,
            },
          ],
        ],
      },
    ],
  },
  {
    text: "FAQ",
    url: Routes.OEE.FAQ,
  },
  {
    text: "GLOSSARY",
    url: Routes.OEE.Glossary,
  },
  {
    text: "ABOUT US",
    url: Routes.OEE.About,
  },
  {
    text: "FREE TOOLS",
    url: Routes.OEE.FreeTools,
  },
];

export default menuItems;
